import axios from "axios";
import { ewbConfig } from "config";
import { REQUEST_TIMEOUT_SECONDS } from "./constants";

export default axios.create({
  baseURL: ewbConfig.ewbApiUrl,
  timeout: REQUEST_TIMEOUT_SECONDS * 1000,
  headers: {
    "Content-Type": "application/json",
  },
});
